import { render } from "./rootControls.vue?vue&type=template&id=47d1cf19&scoped=true&ts=true"
import script from "./rootControls.vue?vue&type=script&lang=ts"
export * from "./rootControls.vue?vue&type=script&lang=ts"

import "./rootControls.vue?vue&type=style&index=0&id=47d1cf19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d1cf19"]])

export default __exports__